import { lazyLoad } from 'utils/loadable';

const WebAuthenticationForm = lazyLoad(() => import('./WebAuthMain'));

const WebRegAuthForm = lazyLoad(() => import('./WebRegAuthMain'));

const WebRegistrationForm = lazyLoad(() => import('./WebRegistration'));

const WebClientAutenticationForm = lazyLoad(() =>
  import('./WebClientAuthMain'),
);

const WebClientRegistrationForm = lazyLoad(() =>
  import('./WebClientRegistration'),
);

// routes declaration
export const authRoutes = [
  {
    component: WebAuthenticationForm,
    hidePublicNavbar: true,
    path: '/signin',
    title: 'Authentication',
    description: 'User authentication.',
    hideCustomFooter: true,
    hideForClientDomain: true,
    hideChatWidget: true,
  },
  {
    component: WebRegAuthForm,
    hidePublicNavbar: true,
    path: '/signup',
    title: 'Signup',
    description: 'User Signup.',
    hideCustomFooter: true,
    hideForClientDomain: true,
    hideChatWidget: true,
  },
  {
    component: WebRegistrationForm,
    hidePublicNavbar: true,
    path: '/registration',
    title: 'Registration',
    description: 'Register your details.',
    hideCustomFooter: true,
    allowedAfterLogin: true,
    hideForClientDomain: true,
    hideChatWidget: true,
  },
  {
    component: WebClientAutenticationForm,
    hidePublicNavbar: true,
    path: '/signin',
    title: 'Signin',
    description: 'User authentication.',
    hideCustomFooter: true,
    showForClientDomain: true,
    hideChatWidget: true,
  },
  {
    component: WebClientRegistrationForm,
    hidePublicNavbar: true,
    path: '/registration',
    title: 'User Registration',
    description: 'Register your details.',
    hideCustomFooter: true,
    allowedAfterLogin: true,
    showForClientDomain: true,
    hideChatWidget: true,
  },
];
